import { render, staticRenderFns } from "./PackageSectionForm.vue?vue&type=template&id=183c2a80"
import script from "./PackageSectionForm.vue?vue&type=script&lang=js"
export * from "./PackageSectionForm.vue?vue&type=script&lang=js"
import style0 from "./PackageSectionForm.vue?vue&type=style&index=0&id=183c2a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports